import { Injectable } from '@angular/core';
import { Http } from './shared/http-client/http-client.component';
import 'rxjs/add/operator/map';
import { Observable } from "rxjs/Observable";
import { EnvironmentSpecificService } from "../environment-specific.service";
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from "@angular/router";
import { take } from 'rxjs/operators';
import { NbDialogService } from '@nebular/theme';
import { DialogConfirmComponent } from './shared/modals/dialog-confirm.component';
import { DialogOKComponent } from './shared/modals/dialog-ok.component';
declare var $: any;
@Injectable()
export class PagesServices {

    apiUrl:any;
    appUrl:any;
    mapConfig:any;
    developmentEnv:boolean = true;
    account_id:any;
    deviceUsers:any = [];
    zoom: number = 14;
    lat: number = 13.736717;
    lng: number = 100.523186;
    SOSusers:any = [];
    SOSinterval:any;
    defaultMins: number = 5000;
    positionBtmRight:"toast-bottom-right";
    private userId:any;
    private userUUId:any;
    dataActivity:any = [];
    listgeofenceactivites:any = [];
    constructor(private _http: Http,
        private _router: Router,
        private _envService: EnvironmentSpecificService,
        private _toastr: ToastrService,
        private _dialogService: NbDialogService) {
            
        this.apiUrl = this._envService.envSpecific.apiUrl;
        this.appUrl = this._envService.envSpecific.appUrl;
        this.mapConfig = this._envService.envSpecific.mapConfig;
        
        this.userId = JSON.parse(localStorage.getItem("currentUser")).username;
        this.userUUId = JSON.parse(localStorage.getItem("currentUser")).id;
        
    }

    GetUserId(){
        return JSON.parse(localStorage.getItem("currentUser")).username;
    }
    GetUserUUId(){
        return JSON.parse(localStorage.getItem("currentUser")).id;
    }
    

    IsPermissionActive(permisson){
        var permissions = JSON.parse(localStorage.getItem("currentUser")).permissions;
        return (permissions.filter(q=>q.key == permisson))[0].value;
    }

    IsUserPermissionActive(permisson){
        var user_permissions = JSON.parse(localStorage.getItem("currentUser")).user_permissions;
        return (user_permissions.filter(q=>q.key == permisson))[0].value;
    }

    addNavigationPreviewTriger(_this){
        var that = _this;
        $(document).off("click",".div_navigationpreview");
        $(document).on("click",".div_navigationpreview",function(){
            if(that.navigationpreview_mode != null){
                _this._pagesService.SetNavigationPreviewDataWithMode(that.navigationpreview_mode,_this.data)
            }else{
                _this._pagesService.SetNavigationPreviewData(that.data)
            }
        });
    }

    
    getCurrentUser() {
        var currentUser = JSON.parse(localStorage.getItem("currentUser"));
        return currentUser.username.toLowerCase();
    }
    
    GetCurrentUserId() {
        var currentUser = JSON.parse(localStorage.getItem("currentUser"));
        return currentUser.id;
    }

    SetNavigationPreviewData(datas){

        var previewdatas = [];
        datas.forEach(data => {
            if(!data.locked || data.lockedUserId == this.GetCurrentUserId()){
                previewdatas.push({
                    id: data.id,
                    type: data.type.toLowerCase()
                });
            }
        });
        localStorage.removeItem("navigationpreviewdata");
        localStorage.setItem('navigationpreviewdata', JSON.stringify(previewdatas));
    }

    SetNavigationPreviewDataWithMode(mode,datas){

        var previewdatas = [];
        if(mode =='bookmark'){
            datas.forEach(data => {
                if(!data.locked || data.lockedUserId == this.GetCurrentUserId()){
                    previewdatas.push({
                        id: data.videoId,
                        type:'video',
                        bookmarkid: data.id
                    });
                }
            });
        }else{
            datas.forEach(data => {
                if(!data.locked || data.lockedUserId == this.GetCurrentUserId()){
                    previewdatas.push({
                        id: data.id,
                        type: mode.toLowerCase()
                    });
                }
            });
        }
        
        localStorage.removeItem("navigationpreviewdata");
        localStorage.setItem('navigationpreviewdata', JSON.stringify(previewdatas));
    }

    GetNavigationPreviewData(){
        return JSON.parse(localStorage.getItem("navigationpreviewdata"));
    }

    RefreshNavigationState(){
        localStorage.setItem("navigationstateclear","clear");
        localStorage.removeItem("navigationstate");
    }

    ListMyFolders(): Observable<any>{
        return this._http.get(this.apiUrl + '/folders/listmyfolders').map((response: Response) => {
            return response;
        });
    }

    GetMyFilesAndFoldersCount(): Observable<any>{
        return this._http.get(this.apiUrl + '/devicecenter/getmyfilesandfolderscount').map((response: Response) => {
            return response;
        });
    }

    GetUserURL(path){
        return this._envService.envSpecific.userURL + path;
    }
    
    ShowUpgradePlanDialog(){
        setTimeout(() => {
            var modalData = {
                title: 'Upgrade Plan',
                size: 'md400',
                body: 'The feature you’re trying to access is not available with your current QUICKTEL Plan.<br/><br/>To enable this feature, please contact our support team to upgrade your plan.<br/><br/>For assistance, reach out to us at <a href=\'mailto:info@quicktelradios.com\'>info@quicktelradios.com</a>'
                }
        
                this._dialogService.open(DialogOKComponent, {
                    context: modalData
                }).onClose.subscribe(result => { 
                
                });
        }, 500);
    }

    numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    parseTags(tagString: string | null): string[] {
        if (!tagString) return [];

        try {
            const parsed = JSON.parse(tagString);
            return Array.isArray(parsed) ? parsed : [];
        } catch {
            return [];
        }
    }

}
